import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

const height = "3rem";
const heightTablet = "5rem";
const heightPhone = "8rem";

export const warningBar = (theme: Theme) => css`
  clear: both;
  height: ${height};

  a,
  button {
    color: ${theme.text.onBackground};
    ${animations.transition()}
  }

  strong {
    color: ${theme.text.onBackground};
  }

  button {
    background-color: inherit;
    border: 0;
  }

  form {
    display: inline;
  }

  p {
    padding: 0.75rem 1.25rem;
    margin: 0;
  }

  svg {
    margin-right: 0.5em;
    color: ${theme.text.onBackground};
  }
`;

export const warningBarContainer = {
  base: css`
    height: ${height};
  `,
  severity: {
    primary: (theme: Theme) => css`
      background-color: ${theme.success.backgroundBase};

      p {
        color: ${theme.text.onBackground};
      }
    `,
    danger: (theme: Theme) => css`
      background-color: ${theme.danger.backgroundBase};
      border-bottom: 1px solid ${theme.danger.textBase};

      p {
        color: ${theme.text.onBackground};
      }
    `,
    warning: (theme: Theme) => css`
      background-color: ${theme.highlight.backgroundBase};
      border-bottom: 1px solid ${theme.highlight.textBase};

      p {
        color: ${theme.highlight.textBase};
      }
    `,
    info: (theme: Theme) => css`
      background-color: ${theme.warning.backgroundBase};

      p {
        color: ${theme.text.onBackground};
      }
    `,
  },
  fixed: css`
    position: fixed;
    z-index: ${layers.indexAlertBar};
    width: 100%;
  `,
};

export const responsiveHeight = css`
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    height: ${heightTablet};
  }
  @media only screen and (max-width: ${dimensions.phoneMax}) {
    height: ${heightPhone};
  }
`;

export const responsiveAutoHeight = css`
  height: fit-content;
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    height: fit-content;
  }
`;

export const warningMessageContainer = css`
  margin: 0 auto;
  max-width: 85.5rem;
  padding: 0 15px;
  width: 100%;

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    max-width: 46.875rem;
  }

  @media only screen and (max-width: ${dimensions.tabletMax}) {
    max-width: 60.625rem;
  }

  @media only screen and (max-width: ${dimensions.desktopMax}) {
    max-width: 85.5rem;
  }

  @media only screen and (min-width: ${dimensions.fullHD}) {
    max-width: 85.5rem;
  }
`;
